import { render, staticRenderFns } from "./ApplicationCompletionDetails.vue?vue&type=template&id=54595a0e"
import script from "./ApplicationCompletionDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationCompletionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports